import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { ICom0104MState, IAttachFileItemState, IBoardDcdItemState, IRecipientItemState } from '../../models/com/com0104m_model';
  
const initialState: ICom0104MState = {
    fileList        : [],
    attachFileItems : [],
    recipientList   : [],
    boardDcdList    : [],

    /* 게시판 */
    boardItems : {
        id :0,                  // ID
        rgstEmpNo: '',          // 등록자사번
        rgstUserNm: '',         // 등록자명
        boardDcd: '',           // 게시판구분
        title: '',              // 제목
        cntnt: '',              // 내용
        switchRecYn: false,     // 재발송여부
    }
}

export const com0104m_Slice = createSlice({
    name: "com0104m_Slice",
    initialState: initialState,
    reducers: {
        initState: (state) => {
            Object.assign(state, {...initialState
                                   , boardDcdList: state.boardDcdList});
        },
        setBoardItems: (state, action:PayloadAction<any>) => {
            state.boardItems = action.payload;
        },
        setRecipientList: (state, action:PayloadAction<IRecipientItemState[]>) => {
            state.recipientList = action.payload;
        },
        setBoardDcdList: (state, action:PayloadAction<IBoardDcdItemState[]>) => {
            state.boardDcdList = action.payload;
        },
        setFileList: (state, action:PayloadAction<[]>) => {
            state.fileList = action.payload;
        },
        setAttachFileItems: (state, action:PayloadAction<IAttachFileItemState[]>) => {
            state.attachFileItems = action.payload;
        },
        setSwitchRecYn: (state, action:PayloadAction<boolean>) => {
            state.boardItems.switchRecYn = action.payload;
        },
        addFileList: (state, action:PayloadAction<File>) => {
            let arr : any[] = [...state.fileList];

            const ttt = arr.filter((item:File) => {
                return item === action.payload
            });

            if (ttt.length < 1) {
                arr.push(action.payload);
                return {
                    ...state,
                    fileList: arr as []
                }
            } else {
                return {
                    ...state,
                }
            }
        },
        addAttachFileItems: (state, action:PayloadAction<IAttachFileItemState>) => {
            const arr : any[] = [...state.attachFileItems];

            const ttt = arr.filter((item:any) => {
                return item.orginFileNm === action.payload.orginFileNm
            });

            if (ttt.length < 1) {
                arr.push(action.payload);
                
                return {
                    ...state,
                    attachFileItems: arr as []
                }
            } else {
                return {
                    ...state,
                }
            }
        },
        removeAttachFileItems: (state, action:PayloadAction<any>) => {
            const arr : any[] = [...state.attachFileItems];

            const ttt = arr.filter((item:any) => {
                return item.orginFileNm !== action.payload.orginFileNm
            });
    
            return {
                ...state,
                attachFileItems: ttt as []
            }
        },
        removeFileList: (state, action:PayloadAction<any>) => {
            const arr : any[] = [...state.fileList];

            const ttt = arr.filter((item:any) => {
                return item.name !== action.payload.orginFileNm
            });

            return {
                ...state,
                fileList: ttt as []
            }
        },
    },
});

export default com0104m_Slice.reducer;
export const Com0104mAction  = com0104m_Slice.actions;
export const Com0104mReducer = com0104m_Slice.reducer;